// extracted by mini-css-extract-plugin
export default {"container":"ScoreDifference_container__rXSZ6"};